module.exports = __webpack_public_path__ + "static/clothing-suit-e418561c6271ee06bdef457c69ee27b6.jpg";